import { render, staticRenderFns } from "./SupportCategoryAdd.vue?vue&type=template&id=d9a23f4c&"
import script from "./SupportCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./SupportCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./SupportCategoryAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports